import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useTranslation } from "react-i18next";

const Footer = ({ complete }) => {
    const [t] = useTranslation();
    const [hasMounted, setHasMounted] = useState(false);
    const year = new Date().getFullYear();

    useEffect(() => {
        const id = requestAnimationFrame(() => {
            requestAnimationFrame(() => setHasMounted(true));
        });
        return () => cancelAnimationFrame(id);
    }, []);

    const wrapperClass = [
        'footer-wrapper',
        hasMounted ? 'footer-wrapper--visible' : 'footer-wrapper--initial',
        complete ? 'footer-wrapper--hidden' : '',
    ].filter(Boolean).join(' ');

    return (
        <div className={wrapperClass}>
            <footer className="py-1 footer">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xs-12 col-sm-8 d-flex align-items-center">

                        </div>
                        <div className="col-xs-12 col-sm-4 text-sm-right">
                            <small className="text-muted">
                                <a href="https://pendulumdev.co.uk" target="_blank" rel="noopener noreferrer" className="text-muted">
                                    {t("copyright", { year })}
                                </a>
                            </small>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

Footer.propTypes = {
    complete: PropTypes.bool,
};

Footer.defaultProps = {
    complete: false,
};

const mapStateToProps = (state) => ({
    complete: !!(state.flip && state.flip.complete),
});

export default connect(mapStateToProps)(Footer);